import {
  Component,
  Inject,
  OnInit,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { switchMap, startWith, map, take, first } from 'rxjs/operators';

import { AppStateService } from '../services/app-state.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { DataService } from '../services/data.service';
import { BudgetService } from '../services/budget.service';

import { Budget, Offer, SubBudget, ISubBudgetTotals, SubBudgetTotals, Project } from './interfaces';
import { PaymentMethods } from '../interfaces/payment-methods';
import { SubBudgetModel } from './models/sub-budget';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AclUser } from '../interfaces/app-user';
import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { AbstractControl } from '@angular/forms/src/model';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { BudgetModel } from './models/budget-model';
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';
import * as moment from 'moment-timezone';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { OrderEntryComponent } from '../order/components/order-entry.component';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { GoogleApiService } from 'ng-gapi'
import { DomSanitizer } from '@angular/platform-browser';
import { from } from 'rxjs/observable/from';



@Component({
  selector: 'app-budget-detail',
  styleUrls: ['./budget-detail.component.css'],
  templateUrl: './budget-detail.component.html'
})
export class BudgetDetailComponent implements OnInit, AfterViewInit, OnDestroy {

  // Set our default values
  public localState = { value: '' };

  public budget: Budget;
  public exportBudget: Budget;  // BUDGET DELLA COMMESSA USA COLLEGATA

  private updatedProject: Project;


  public bId;
  public sbColl: Observable<Partial<SubBudget>[]>;
  public budgetFolderLink;
  public tabObs: Observable<Partial<SubBudget>[]>;

  // SUBJECT TO DEBOUNCE SUBBUDGET CHANGE
  private subBudgetValues = new BehaviorSubject(new Map<String, ISubBudgetTotals>());
  private subBudgetValuesForChart;
  private sbCollNameMap = new Map<String, String>();

  public offerUrl;
  public poCreating = false;
  public budgetTotalCost = null;
  public totalRefreshDisabled = false;
  public isEditable = true;
  public importingBoM = false;

  public removeExportLinkBtn = false;
  public createExportBudgetBtn = false;

  private activeSubBudgets = [];

  public oData: Offer;
  public oDataExport: Offer;

  public tagFilter: string[] = [];

  public tags$;

  // BUDGET SUMMARY
  public budgetDataSource: MatTableDataSource<SummaryElement>;
  public budgetDisplayedColumns = ['name', 'cost', 'profit', 'expenses', 'commission', 'customDuties', 'total'];
  public summaryData = [];

  // EXPORT SUMMARY
  public exportBudgetDataSource: MatTableDataSource<SummaryElement>;
  public exportBudgetDisplayedColumns = ['name', 'cost', 'profit', 'expenses', 'commission', 'customDuties', 'total', 'totalCurrency'];
  public exportSummaryData = [];

  // Permission flags
  public canChangeStatus: boolean;
  public canAddSubBudget: boolean;

  // Offer templates
  public offerTemplates = [];
  public offerExportTemplates = [];
  public cosmoEnabled: boolean;

  private userId;
  private budgetSubscription;
  private budgetCol$;

  private globalSettings;

  /**** Permission Flags */
  private _canAssignBudget;
  private _canSeeFigures;
  private _canOpenProject;
  private _canArchiveProject;
  graphObs: Observable<Map<String, ISubBudgetTotals>>;

  get canSeeFigures(): boolean {
    return this._canSeeFigures;
  }

  get canOpenProject(): boolean {
    return this._canOpenProject;
  }

  get canArchiveProject(): boolean {
    return this._canArchiveProject;
  }

  get canAssignBudget(): boolean {
    return this._canAssignBudget;
  }


  // TypeScript public modifiers
  constructor(
    private router: Router,
    private dataService: DataService,
    private budgetService: BudgetService,
    private configService: ConfigService,
    private auth: AuthService,
    public appState: AppStateService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public gDocDialog: MatDialog,
    private gapiService: GoogleApiService
  ) { }

  public ngOnInit() {

    //console.log(this.auth.currentUser.email);

    this.exportBudgetDataSource = new MatTableDataSource(this.exportSummaryData);
    this.budgetDataSource = new MatTableDataSource(this.summaryData);

    

    this.budgetSubscription = this.route.paramMap
      .switchMap((params: ParamMap) => {
        this.bId = params.get('id');
        
        console.log('Subscribe to: ', this.bId);
        return this.dataService.getBudget(this.bId);
      })
      .subscribe((b) => {
        if (!b) {
          this.appState.showError({ errorCode: -1, errorMessage: 'Unable to find this budget id' });
          this.router.navigate(['/budget']);
        }
        console.log('BUDGET INFO', b);
        this.budget = b;
        this.tagFilter = this.budget.filter ? this.budget.filter : [];
        this.offerUrl = b.offerUrl;
        this.budgetFolderLink = 'https://drive.google.com/drive/folders/' + b.driveFolderId;
        this.isEditable = BudgetModel.isEditable(b);

        if (b.project && b.prosperworks && !b.project.internal && this.globalSettings.cosmo.enabled) {
          this.dataService.getBudgetPaymentStatus(b.id, b.project.projectNr, b.project.finalOfferOrder, this.globalSettings.prosperworks.whDomain, b.prosperworks.company_id)
            .subscribe();
        }


        // CALCULATE SUMMARY
        if ('costSummary' in b) {
          this.budgetTotalCost = b.costSummary.total;

          if ('margin' in b) {
            this.updateBudgetSummary();
            this.budgetDataSource.data = this.summaryData;
            this.offerData();
          }

        } else if (b.imported && b.budgetAmount) {
          this.budgetTotalCost = b.budgetAmount;
        } else {
          this.budgetTotalCost = null;
        }
        if (b.export) {
          // Export budget are dummies
        } else if (b.exportBudget) {
          this.createExportBudgetBtn = false;
          // SUBSCRIBE TO USA BUDGET
          this.dataService.getBudgetByRef(b.exportBudget)
            .subscribe((bUSA) => {
              if (bUSA) {
                this.exportBudget = bUSA;
                this.updateExportSummary();
                this.exportBudgetDataSource.data = this.exportSummaryData;
                this.offerDataExport();

              } else {
                this.appState.showError({ errorCode: -1, errorMessage: 'The linked export budget does not exist anymore' });
                // TODO
                this.removeExportLinkBtn = true;
              }


            });
        } else if (b.project && b.project.internal) {
          // do not allow to gerate exort for internal project
          this.createExportBudgetBtn = false;
          this.removeExportLinkBtn = false;
        } else if (b.status && b.status === 'archived') {
          this.createExportBudgetBtn = false;
          this.removeExportLinkBtn = false;
        } else {
          this.createExportBudgetBtn = true;
          this.removeExportLinkBtn = false;
        }

        

      }, (err) => {
        console.log('ERROR GETTING BUDGET', err.message);
      });

    this.tags$ = this.route.paramMap
      .switchMap((params: ParamMap) => this.dataService.getSubBudgetCollection(this.bId)).map(subs => {
      const tags = [];

      subs.forEach(sb => {
        if (sb.tags) {
          sb.tags.forEach(t => {
            if (tags.indexOf(t) === -1) {
              tags.push(t);
            }
          });

        }
      });

        this.tagFilter = this.tagFilter.filter(t => (tags.indexOf(t) > -1));

      return tags;

    })

    this.sbColl = this.route.paramMap
      .switchMap((params: ParamMap) => this.dataService.getSubBudgetCollection(this.bId))
      .do((sbc) => {
        console.log('SUB BUDGET coll', sbc);
        sbc.forEach(sb => {
          this.sbCollNameMap.set(sb.id, sb.description);
        });
      })
      .map(sbc => {
        const sbcF = sbc.filter(sb => sb.deleted === undefined || sb.deleted === false || sb.deleted === null);

        this.activeSubBudgets = sbcF;

        return sbcF.map((sb) => ({
          id: sb.id,
          report: sb.report,
          overrideEdit: sb.overrideEdit,
          description: sb.description,
          tags: sb.tags,
          calculate: sb.calculate
        }));
      })
      .distinctUntilChanged((sbcEasy1, sbcEasy2) => {
        
        if (sbcEasy1.length !== sbcEasy2.length) {
          return false;
        }
        for (const idx in sbcEasy1) {
          if (sbcEasy1[idx].id !== sbcEasy2[idx].id ||
            sbcEasy1[idx].calculate !== sbcEasy2[idx].calculate ||
            sbcEasy1[idx].report !== sbcEasy2[idx].report ||
            sbcEasy1[idx].description !== sbcEasy2[idx].description ||
            sbcEasy1[idx].overrideEdit !== sbcEasy2[idx].overrideEdit ||
            ((sbcEasy1[idx].tags && sbcEasy2[idx].tags) && (sbcEasy1[idx].tags.length !== sbcEasy2[idx].tags.length))) {
            return false;
          }
        }
        return true;
      })

    this.configService.settings.subscribe((sett) => {
      if (sett) {
        this.globalSettings = sett.value;
        try {
          this.offerTemplates = sett.value.googleDrive.offerTemplates;
          this.offerExportTemplates = sett.value.googleDrive.offerExportTemplates;
          this.cosmoEnabled = sett.value.cosmo.enabled;
        } catch (err) {
          //
        }
      }
    });

    /** Permission subscription */
    this.auth.userHasPermissions(['app.budget.assign', 'app.budget.project.open',
    'app.budget.figures.read', 'app.budget.write', 'app.iproject.write'])
    .subscribe((val) => {
      this._canAssignBudget = val[0];
      this.canChangeStatus = val[0];
      this._canOpenProject = val[1];
      this._canArchiveProject = val[1];
      this._canSeeFigures = val[2];
      // if (this.budget.project && this.budget.project.internal) {
      //   this.canAddSubBudget = val[4];
      // } else {
      //   this.canAddSubBudget = val[3];
      // }
      this.canAddSubBudget = val[3] || val[4];
    });

    this.graphObs = this.updateGraph()

    this.graphObs.debounceTime(2000)
      .subscribe(() => {
        this.getCostSummary();
      });
    

    

  }

  public filterChange(){
    console.log('filterchange', this.tagFilter);

    this.dataService.patchBudget(this.budget.id,{
      filter: this.tagFilter
    }).then(() => {
      return this.activeSubBudgets.forEach(sb => {
        this.dataService.updateSubBudgetField(this.budget.id, sb.id, {
          calculate: this.checkFilters(sb.tags)
        }).then(data => {
          console.log("updating this sb", sb, this.checkFilters(sb.tags))

          const sbValMap = this.subBudgetValues.value;
          const sbVal = sbValMap.get(sb.id);
          sbVal.calculate = this.checkFilters(sb.tags);
          sbValMap.set(sb.id, sbVal);
          this.subBudgetValues.next(sbValMap);

        })
      })
    })

    

    
  }

  public toggleCalculate(event,sb){
    console.log(sb,event,this.checkFilters(event));
    this.dataService.updateSubBudgetField(this.budget.id, sb.id, {
      
      calculate: this.checkFilters(event)
    })
  }

  public checkFilters(tags){
    if (tags) {
      return this.tagFilter.length === 0 || tags.some(tag => (this.tagFilter.indexOf(tag) > - 1));
    } else {
      return this.tagFilter.length === 0;
    }
    
  }


  public createOfferDocument(data) {
    this.poCreating = true;
    this.dataService.createOfferDocument(data.productSelected, data.imageList).first()
    .subscribe((res) => {
      this.poCreating = false;
      console.log('logging results', res);
    }, err => {
      console.log(' createOfferDocument error', err);
    }, () => {
      this.poCreating = false;
    });
  }

  public updateGraph(){
    return this.subBudgetValues
    .do((val) => {
      const ret = [];
      val.forEach((value: ISubBudgetTotals, key) => {
        
        if(value.calculate){
          ret.push({
            name: this.sbCollNameMap.get(key),
            series: [
              {
                name: 'Activities',
                value: value.calculate ? value.activities : 0
              },
              {
                name: 'Materials',
                value: value.calculate ? value.materials : 0
              }
            ]
          });
        }
        
      });
      this.subBudgetValuesForChart = ret;
    });
  }

  public removeExportLink() {
    this.dataService.patchBudget(this.bId, {
      exportBudget: null
    });
  }

  public setStatus(status): void {
    if (status === this.budget.status) {
      return;
    }
    if (['new', 'edit', 'closed'].indexOf(status) > -1) {
      this.dataService.patchBudget(this.budget.id, {
        status: status
      });
    }
  }

  public openOfferWizard(): void {
    // console.log("global settings", this.globalSettings)
    this.gDocDialog.open(DocumentEditorDialogComponent, {
      width: '500px',
      data: {
        templates: this.globalSettings.googleDrive.offerTemplates,
        budgetFolder: this.budget.driveFolderId,
        imageFolderPath: this.globalSettings.googleDrive.imageFolderPath,
      }
    }).afterClosed().subscribe(data => {
      //this.createOfferDocument(data)
      if (data){
        this.prepareOfferWithTemplate(data.imageList, data.productSelected.templateId,null, null )
      }

    })
  }

  public openDialog(): void {
    // Get the list of users
    this.dataService.getAppUsers().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as AclUser;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    }).subscribe(d => {
      console.log('Users data', d);
      const dialogRef = this.dialog.open(ContactPickerDialogComponent, {
        width: '350px',
        data: { users: d }
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed ', result);
        if (!result) {
          return;
        }
        this.dataService.assignBudget(
          result.user,
          this.bId,
          result.deliveryThr = moment(result.deliveryThr).toDate(),
          result.noteToPrjMgr
        )
          .subscribe(data => {
            console.log('Update resutl', data);
          });
      });
    });
  }

  private offerData() {
    const oData = <any>{};
    this.summaryData.forEach((el: SummaryElement) => {
      switch (el.id) {
        case 'production':
          oData.productionAmount = el.total;
          break;
        case 'design':
          oData.designAmount = el.total;
          break;
        case 'shipping':
          oData.shippingAmount = el.total;
          break;
        case 'assembly':
          oData.assemblyAmount = el.total;
          break;
        case 'total':
          oData.offerAmount = el.total;
          break;
      }
    });
    this.oData = oData;
    return oData;
  }

  private offerDataExport() {
    const oData = <any>{};
    this.exportSummaryData.forEach((el: SummaryElement) => {
      switch (el.id) {
        case 'production':
          oData.productionAmount = el.totalCurrency;
          break;
        case 'design':
          oData.designAmount = el.totalCurrency;
          break;
        case 'shipping':
          oData.shippingAmount = el.totalCurrency;
          break;
        case 'assembly':
          oData.assemblyAmount = el.totalCurrency;
          break;
        case 'total':
          oData.offerAmount = el.totalCurrency;
          this.exportBudget.costSummary.total = el.cost;
          break;
      }
    });
    this.oDataExport = oData;
    return oData;
  }

  public createExportBudget() {
    if (this.budget.exportBudget) {
      console.log('This budget already has a linked export budget');
      return;
    }
    this.dataService.createExportBudget(this.budget)
      .then(() => {
        console.log('Export Budget Created');
      });
  }

  public createSummaryPDF() {
    console.log(this.budget);
    const summaryData: any = {
      budgetNr: this.budget.budgetNr,
      budgetDescription: this.budget.prosperworks ? this.budget.prosperworks.name : '',
      clientName: this.budget.companyName ? this.budget.companyName : (this.budget.prosperworks ? this.budget.prosperworks.company_name : ''),
      costSummary: {},
      materialSummary: {},
      activitySummary: {},
      status: this.budget.status ? this.budget.status : 'archived',
      assignee: this.budget.assignee ? this.budget.assignee : null,
      creationDate: this.budget.creation,
      archivedDate: this.budget.archivedDate ? this.budget.archivedDate : ''
    };

    if (this.budget.project) {
      summaryData.project = this.budget.project;
      summaryData.deliveryDate = this.budget.project.deliveryDate ? this.budget.project.deliveryDate : this.budget.creation;
    }

    let budgetActivities = [];
      const reducedBudgetActivities = [];
     let activitySummary = [];

    const activitySummary$ = this.dataService.getAllBudgetActivities(this.budget.id).first();

    const costSummary$ = this.budgetService.getSummaryBalanceByBudget(this.budget.id).first();

    const materialSummary$ = this.dataService.getOrdersByBudget(this.budget.id).first()
    .map((orders) => {

      const flatMat = [];

      console.log('the orders', orders)

      for (const order of orders) {
        for (const item of order.items) {
          if (item.budget.id === this.budget.id) {
            const el = {
              item,
              orderId: order.id,
              orderNr: order.orderNr,
              date: <Date>order.date,
              deleted: order.deleted,
              author: order.author.displayName,
              vendor: order.vendor.name,
              total: OrderEntryComponent.calculateEntryValue(item)
            };
            flatMat.push(el);
          }

        }
      }

      return flatMat;

    });

    return combineLatest([costSummary$, materialSummary$, activitySummary$]).first().map(data => {
      const cs = data[0];
      const ms = data[1];
      const as = data[2];

      return as.then(acts => {
        acts.forEach(act => {

          budgetActivities = budgetActivities.concat(act.docs.map(doc => doc.data()));

        });

        // console.log(this.budgetActivities);

        budgetActivities.forEach(ba => {
          const reducedBA = reducedBudgetActivities.find(a => {
            return ba.activity === a.activity;
          });

          const finalHours = ba.finalHours ? ba.finalHours : 0;
          const hours = ba.hours ? ba.hours : 0;

          if (reducedBA) {
            reducedBA.hours += Number(hours);
            reducedBA.cost += Number(ba.cost) * Number(hours);

          } else {
            reducedBudgetActivities.push({
              activity: ba.activity,
              category: ba.category,
              hourlyCost: Number(ba.cost),
              hours: Number(hours),
              cost: Number(ba.cost) * hours,
              finalCost: 0,
              finalHours: 0,
              actualCost: 0

            });
          }
        });

        // console.log("Reduced ---->>", this.reducedBudgetActivities)

        activitySummary = reducedBudgetActivities;

        return this.dataService.getTimereportByBudget(this.budget.id)
          .first()
          .switchMap(trData => {
            // console.log(data.map(doc => doc.payload.doc.data()));

            trData.forEach(doc => {
              const TRAct = doc.payload.doc.data();

              const resAct = activitySummary.find(ra => {

                if(TRAct.activity){
                  return ra.activity === TRAct.activity.activity;
                } else {
                  return false;
                }
              });


              if (resAct) {
                resAct.finalHours += TRAct.hours;
                resAct.finalCost += TRAct.actualCost ? (TRAct.actualCost * TRAct.hours) : 0;
                resAct.actualCost = TRAct.actualCost ? TRAct.actualCost : 0;
              } else {
                activitySummary.push({
                  activity: TRAct.activity ? TRAct.activity.activity : '',
                  category: TRAct.activity ? TRAct.activity.category : '',
                  hourlyCost: 0,
                  hours: 0,
                  cost: 0,
                  finalHours: TRAct.hours,
                  finalCost: TRAct.actualCost ? (TRAct.actualCost * TRAct.hours) : 0,
                  actualCost: TRAct.actualCost ? TRAct.actualCost : 0
                });
              }

            });

            summaryData.activitySummary = activitySummary;
            summaryData.materialSummary = ms;
            summaryData.costSummary = cs;
            console.log('final summary', summaryData);
            return from(this.budgetService.createSummaryDoc(summaryData, this.budget.id));
          });
      });
    });
  }

  public prepareExportOffer(offerTemplate?: OfferTemplate) {
    return this.prepareOffer(offerTemplate,  this.exportBudget);
  }

  public prepareOffer(offerTemplate?: OfferTemplate, eBudget?: Budget) {

    this.poCreating = true;

    // Update Offer Values
    let locale = 'it-IT';
    let budget;
    if (eBudget) {
      eBudget.offer = this.offerDataExport();
      budget = <any>eBudget;
      locale = 'en-US';
    } else {
      this.budget.offer = this.offerData();
      budget = <any>this.budget;
    }

    console.log('budget per offer', budget);

    let o1;
    if (budget.prosperworks && budget.prosperworks.company_id) {
      o1 = Observable.forkJoin(
        this.dataService.getCompanyById(budget.prosperworks.company_id),
        this.dataService.getPersonById(budget.prosperworks.primary_contact_id)
      );
    } else {
      o1 = Observable.of([null, null]);
    }
    // Retrieve company data
    o1.switchMap(([company, primary]) => {
      // console.log('aaa', aaa);
      // const company = aaa[0];
      // const primary = aaa[1];

      let offerData;
      if (!budget.prosperworks) {
        offerData = {
          company: budget.client,
          project: budget.name,
          subject: budget.description
        };
      } else {
        const pw = budget.prosperworks;
        offerData = {
          company: pw.company_name,
          project: pw.name,
          subject: pw.details,
        };

        if (company) {
          offerData.address = company.address ? company.address.street : '';
          offerData.zip_code = company.address ? company.address.postal_code : '';
          offerData.city = company.address ? company.address.city : '';
          offerData.country = company.address ? company.address.country : '';
        }

        if (primary) {
          offerData.primary_contact = primary.name;
        }


        if (eBudget) {
          offerData.date = moment.tz(new Date(), 'Europe/Rome').format('MM/DD/YYYY');
        }
        else {
          offerData.date = moment.tz(new Date(), 'Europe/Rome').format('DD/MM/YYYY');
        }

          offerData.BU_number = budget.budgetNr;
        offerData.chapter_3 = 'Offerta Economica';
        offerData.chapter_3_item_1 = 'Produzione';

        offerData.section_1_title = 'Produzione';
        // offerData.section_2_title = 'Progettazione';
        // offerData.section_3_title = 'Trasporto';
        // offerData.section_4_title = 'Montaggio';

        try {
          console.log('Found template ', offerTemplate);
          offerData.idModello = offerTemplate.templateId;
          locale = offerTemplate.locale ? offerTemplate.locale : locale;
          if (!offerData.idModello) {
            throw new Error('Template not found for ' + offerTemplate);
          }
          console.log('Using template ', offerData.idModello);
        } catch (err) {
          console.log('Using default template because of', err);
          offerData.idModello = '1H5Ip_j_egwbLoYwO-fGIUOOr_32eoLwApt40sLFBj5o';
        }

        const printNumber = (n: number) => {
          try {
            if (n) {
              return n.toLocaleString(locale, {
                maximumFractionDigits: 2
              });
            } else {
              return '';
            }
          } catch (err) {
            console.warn('Cannot convert value to string', n);
            return '';
          }
        };

        offerData.section_1_amount = printNumber(budget.offer.productionAmount);
        offerData.section_2_amount = printNumber(budget.offer.designAmount);
        offerData.section_3_amount = printNumber(budget.offer.shippingAmount);
        offerData.section_4_amount = printNumber(budget.offer.assemblyAmount);

        offerData.total_amount = printNumber(budget.offer.offerAmount);
        offerData.drawings_weeks = 3;
        offerData.approval_weeks = 4;
        offerData.production_weeks = 10;

        offerData.subFolderName = 'Documenti';

        const driveFolderId = this.budget.driveFolderId ? this.budget.driveFolderId : '1O42HTaUnFElDR92sljnBKH6kAAxlSIdX';
        // TODO id driveFolderId is not defined skip to a defult value
        console.log('Direv folder id', driveFolderId);

        offerData.idCartellaDestinazione = driveFolderId;
        offerData.nomeDocumento = budget.budgetNr + '-' + pw.name;

        console.log('offerData', offerData);

      }
      return this.dataService.prepareOffer(offerData);
    }).subscribe((d) => {
      console.log('ret', d);
      this.poCreating = false;

      if (!d.response || !d.response.result || d.response.result.returnCode || ! d.response.result.documentUrl) {
        return this.appState.showError({
            errorCode: ( d.response && d.response.result ) ? d.response.result.returnCode : -1,
            errorMessage: 'The offer was not created',
            errorSource: d.response
          });
      }

      this.dataService.patchBudget(budget.id, { offerUrl: String(d.response.result.documentUrl) })
        .then(() => {
          console.log('Budget updated');
        });
      // this.offerUrl = d.response.result.documentUrl;
      if (this.budget.prosperworks) {
        // this.dataService.pushDocToPw(this.budget.prosperworks.opportunity_id, this.offerUrl);
      }
    }, (err) => {
      this.poCreating = false;
      console.log(err);
      // this.appState.showError({
      //   errorCode: err.code ? err.code : -1,
      //   errorMessage: 'The offer was not created',
      //   errorSource: err
      // });
    }, () => {
      this.poCreating = false;
    }
    );


  }



  public prepareOfferWithTemplate(images, templateId, offerTemplate?: OfferTemplate, eBudget?: Budget) {

    this.poCreating = true;

    // Update Offer Values
    let locale = 'it-IT';
    let budget;
    if (eBudget) {
      eBudget.offer = this.offerDataExport();
      budget = <any>eBudget;
      locale = 'en-US';
    } else {
      this.budget.offer = this.offerData();
      budget = <any>this.budget;
    }

    console.log('budget per offer', budget);

    let o1;
    if (budget.prosperworks && budget.prosperworks.company_id) {
      o1 = Observable.forkJoin(
        this.dataService.getCompanyById(budget.prosperworks.company_id),
        this.dataService.getPersonById(budget.prosperworks.primary_contact_id)
      );
    } else {
      o1 = Observable.of([null, null]);
    }
    // Retrieve company data
    o1.switchMap(([company, primary]) => {
      // console.log('aaa', aaa);
      // const company = aaa[0];
      // const primary = aaa[1];

      let offerData;
      if (!budget.prosperworks) {
        offerData = {
          company: budget.client,
          project: budget.name,
          subject: budget.description
        };
      } else {
        const pw = budget.prosperworks;
        offerData = {
          company: pw.company_name,
          project: pw.name,
          subject: pw.details,
        };

        if (company) {
          offerData.address = company.address ? company.address.street : '';
          offerData.zip_code = company.address ? company.address.postal_code : '';
          offerData.city = company.address ? company.address.city : '';
          offerData.country = company.address ? company.address.country : '';
        }

        if (primary) {
          offerData.primary_contact = primary.name;
        }


        if (eBudget) {
          offerData.date = moment.tz(new Date(), 'Europe/Rome').format('MM/DD/YYYY');
        }
        else {
          offerData.date = moment.tz(new Date(), 'Europe/Rome').format('DD/MM/YYYY');
        }

          offerData.BU_number = budget.budgetNr;
        offerData.chapter_3 = 'Offerta Economica';
        offerData.chapter_3_item_1 = 'Produzione';

        offerData.section_1_title = 'Produzione';
        // offerData.section_2_title = 'Progettazione';
        // offerData.section_3_title = 'Trasporto';
        // offerData.section_4_title = 'Montaggio';

        try {
          console.log('Found template ', offerTemplate);
          offerData.idModello = offerTemplate.templateId;
          locale = offerTemplate.locale ? offerTemplate.locale : locale;
          if (!offerData.idModello) {
            throw new Error('Template not found for ' + offerTemplate);
          }
          console.log('Using template ', offerData.idModello);
        } catch (err) {
          console.log('Using default template because of', err);
          offerData.idModello = '1H5Ip_j_egwbLoYwO-fGIUOOr_32eoLwApt40sLFBj5o';
        }

        const printNumber = (n: number) => {
          try {
            if (n) {
              return n.toLocaleString(locale, {
                maximumFractionDigits: 2
              });
            } else {
              return '';
            }
          } catch (err) {
            console.warn('Cannot convert value to string', n);
            return '';
          }
        };

        offerData.section_1_amount = printNumber(budget.offer.productionAmount);
        offerData.section_2_amount = printNumber(budget.offer.designAmount);
        offerData.section_3_amount = printNumber(budget.offer.shippingAmount);
        offerData.section_4_amount = printNumber(budget.offer.assemblyAmount);

        offerData.total_amount = printNumber(budget.offer.offerAmount);
        offerData.drawings_weeks = 3;
        offerData.approval_weeks = 4;
        offerData.production_weeks = 10;

        offerData.subFolderName = 'Documenti';

        const driveFolderId = this.budget.driveFolderId ? this.budget.driveFolderId : '1O42HTaUnFElDR92sljnBKH6kAAxlSIdX';
        // TODO id driveFolderId is not defined skip to a defult value
        console.log('Dirve folder id', driveFolderId);

        offerData.idCartellaDestinazione = driveFolderId;
        offerData.nomeDocumento = budget.budgetNr + '-' + pw.name;

        console.log('offerData', offerData);

      }
      return this.dataService.generateOfferDocument(offerData, images, templateId);
    }).subscribe((d) => {
      console.log('created WS Offer document', d);
      this.poCreating = false;
      this.dataService.patchBudget(this.bId, { offerUrl: String(d.documentUri) })
      .then(() => {
        console.log('Budget updated');
      });
    }, (err) => {
      this.poCreating = false;
      console.log(err);

    }
    );


  }

  public sendOffer() {
    this.appState.showError({
      errorCode: 100,
      errorMessage: 'Not implemented'
    });
  }


  // TODO Cleanup
  public getBudgetSubtotals($event) {
    this.dataService.getBudgetSubtotals(this.bId)
      .subscribe((data) => {
        // console.log('Subtotals ', data);
        this.totalRefreshDisabled = false;
      }, (err) => {
        console.log('Error ', err);
      });
  }

  public updateSubBudgetValues($event: ISubBudgetTotals, sbId) {
    const sbValMap = this.subBudgetValues.value;
    sbValMap.set(sbId, $event);
    this.subBudgetValues.next(sbValMap);
  }

  public deleteSubBudget(subBudgetId: string) {
    const sbValMap = this.subBudgetValues.value;
    console.log('deleteSubBudget - deleting subBudget', subBudgetId, sbValMap);

    if (sbValMap.delete(subBudgetId)) console.log('deleteSubBudget - deleted');
    this.subBudgetValues.next(sbValMap);
  }

  public importFromSheet() {
    // this.dataService.getBudgetCostSummary(this.bId)
    // .debounceTime(3000)
    // .pipe(take(1))
    // .toPromise()
    //   .then((data) => {
    //     console.log('Data from sheet ', data);
    //     // this.totalRefreshDisabled = false;
    //   })
    //   .then((data) => {
        console.log("IS BUDGET", this.budget);
        if (!this.budget) {
          return false;
        } else {
          this.importingBoM = true;
          return this.dataService.importDataFromSheet(this.budget.driveFolderId, this.budget.id)
          .pipe(take(1))
          .toPromise()
      .then((data) => {
        if (data) {
          console.log('Data from sheet 2 ', data);
          this.importingBoM = false;
        }
      })
      .catch( (err) => {
        console.log('Error ', err);
        this.importingBoM = false;
      });
    }
  }

  public getCostSummary() {
    this.totalRefreshDisabled = true;
    this.dataService.getBudgetCostSummary(this.bId)
    .debounceTime(3000)
    .pipe(take(1))
    .toPromise()
      .then((data) => {
        console.log('Cost summary ', data);
        // this.totalRefreshDisabled = false;
      })
      .then((data) => {
        console.log('IS BUDGET', this.budget);
        if (this.budget && this.budget.exportBudget) {
          return this.dataService.getBudgetCostSummary(this.budget.exportBudget.id)
          .pipe(take(1))
          .toPromise();
        } else {
          return;
        }
      })
      .then((data) => {
        if (data) {
          console.log('Export cost summary ', data);
        }
        this.totalRefreshDisabled = false;
      })
      .catch( (err) => {
        console.log('Error ', err);
        this.totalRefreshDisabled = false;
      });
  }

  public openProject() {
    const dialogRef = this.dialog.open(OpenProjectDialogComponent, {
      width: '350px',
      data: { budget: this.budget, user: this.budget.assignee, oData: this.oData }
    });

    dialogRef.afterClosed()
      .filter(result => result)
      .subscribe(result => {
        console.log('The dialog was closed ', result);
        this.dataService.openProject(this.bId, result.projectNr, result.totalValue, result.projectManager, result.paymentMethod, result.paymentMethodCode, result.deliveryDate)
          .subscribe(data => {
            console.log('Update result', data);
          });
      });
  }

  public getReportFile() {

   return this.dataService.getBudgetSummary(this.budget.id).then(summarySnap => {
      if (summarySnap.exists) {
        return this.dataService.createSummaryPdf(this.budget.id).first().subscribe(data => {
          console.log('Summary execution terminated: ', data);
        });
      } else {
        this.updatedProject = this.budget.project;
        return this.createSummaryPDF()
        .first()
        .subscribe(data => {
          return data.then(summary => {
            console.log(summary);
              summary.first().subscribe(sum => {
                this.dataService.createSummaryPdf(this.budget.id).first().subscribe(result => {
                  console.log('Summary execution terminated: ', result);
                });
              });
            });
          });
      }
    })

    
  }

  
  public archive() {
    if (this.budget.project) {
      return this.archiveProject();
    } else {
      return this.archiveBudget();
    }
  }

  private archiveBudget() {
    this.appState.confirmDialog({ confirmMessage: 'Budget will be archived' })
      .then((result) => {
        if (result && result.confirm) {
          const archivesDate = new Date();
          this.budget.archivedDate = archivesDate;
          return this.dataService.patchBudget(this.budget.id, { archivedDate: archivesDate })
            .then(() => {
              return this.createSummaryPDF().toPromise();
            })
            .then(data => {
              console.log("this is data --->", data);
              return data.toPromise();
            })
            .then(summary => {
              console.log('Summary is', summary);
              return this.dataService.updateBudgetStatus(this.budget.id, 'archived');
            })
            .then((d) => {
              console.log('Project archived', d);
            });
        }
      });
  }

  private archiveProject() {

    const dialogRef = this.dialog.open(ArchiveProjectDialogComponent, {
      width: '350px',
      data: this.budget.project
    });

    return dialogRef.afterClosed()
      .filter(result => result)
      .subscribe(result => {

        const archivesDate = new Date();

        this.updatedProject = this.budget.project;
        this.updatedProject.finalInvoiced = result.finalInvoiced;
        this.budget.archivedDate = archivesDate;

        return this.dataService.patchBudget(this.budget.id, { archivedDate: archivesDate, project: this.updatedProject })
          .then(() => {
            console.log('Project Patched');
            return this.createSummaryPDF().toPromise();
          })
          .then(data => {
            console.log("this is data --->", data);
            return data.toPromise();
          })
          .then(summary => {
            console.log(summary);
            return this.dataService.updateBudgetStatus(this.budget.id, 'archived');
          })
          .then((d) => {
            console.log('Project archived', d);
          })
          .catch(err => {
            console.error('Error while archiving a project', err);
          });

      });
  }

  public addSubBudget(sb: SubBudgetModel) {
    console.log('I\'m the parent ', sb);
    this.dataService.addSubBudget(this.bId, sb.description, sb.generatedBy)
      .subscribe((r) => {
        // Navigate to the the new tab
        console.log('Just created ', r);
      });
  }

  public setUserId(id) {
    this.userId = id;
  }

  public ngAfterViewInit() {

  }

  public ngOnDestroy() {
    this.subBudgetValues.complete();
    this.budgetSubscription.unsubscribe();
  }

  private updateBudgetSummary = () => {
    if (!this.budget || !this.budget.costSummary || !this.budget.margin) {
      return;
    }

    this.summaryData = [];

    const b = this.budget;
    const f = this._calculatesValue(b.margin);
    // Assembly 0
    this._elaborateSummaryElement('assembly', 'Installation', b, f);
    // Design 1
    this._elaborateSummaryElement('design', 'Design', b, f);
    // Production 2
    this._elaborateSummaryElement('production', 'Production', b, f);
    // Shipping 3
    this._elaborateSummaryElement('shipping', 'Shipping', b, f);
    // Custom 4
    this._elaborateSummaryElement('customDuties', 'Customs', b, f);

    const total = this.summaryData.map((el) => el).reduce((el1, el2) => {
      return {
        id: 'total',
        name: 'TOTAL',
        cost: el1.cost + el2.cost,
        profit: el1.profit + el2.profit,
        expenses: el1.expenses + el2.expenses,
        customDuties: el1.customDuties + el2.customDuties,
        commission: el1.commission + el2.commission,
        total: el1.total + el2.total,
        totalCurrency: el1.totalCurrency + el2.totalCurrency
      };
    },
      {
        id: 'total',
        name: 'TOTAL',
        cost: 0,
        profit: 0,
        expenses: 0,
        customDuties: 0,
        commission: 0,
        total: 0,
        totalCurrency: 0
      });
    this.summaryData.push(total);
  }

  private updateExportSummary = () => {
    if (!this.exportBudget || !this.exportBudget.costSummary || !this.exportBudget.margin) {
      return;
    }

    this.exportSummaryData = [];

    const b = this.exportBudget;
    const f = this._calculatesValue(b.margin, b.export.exchangeRate);
    console.log('SUMMARY', this.exportSummaryData);
    // Assembly
    this._elaborateExportSummaryElement('assembly', 'Installation', b, f);
    // Design
    this._elaborateExportSummaryElement('design', 'Design', b, f);
    // Production
    this._elaborateExportSummaryElement('production', 'Production', b, f);
    // Shipping
    this._elaborateExportSummaryElement('shipping', 'Shipping', b, f);
    console.log('SUMMARY', this.exportSummaryData);
    const total = this.exportSummaryData.map((el) => el).reduce((el1, el2) => {
      return {
        id: 'total',
        name: 'TOTAL',
        cost: el1.cost + el2.cost,
        profit: el1.profit + el2.profit,
        expenses: el1.expenses + el2.expenses,
        customDuties: el1.customDuties + el2.customDuties,
        commission: el1.commission + el2.commission,
        total: el1.total + el2.total,
        totalCurrency: el1.totalCurrency + el2.totalCurrency
      };
    },
    {
      id: 'total',
      name: 'TOTAL',
      cost: 0,
      profit: 0,
      expenses: 0,
      customDuties: 0,
      commission: 0,
      total: 0,
      totalCurrency: 0
    });
    this.exportSummaryData.push(total);

  }

  private _elaborateExportSummaryElement = (elId: string, name: string, b: Budget, f) => {
    if (elId in b.costSummary) {
      const cost = b.costSummary[elId];
      // const iCost = this.summaryData.find((o) => o.id === elId);
      // if (iCost && iCost.total) {
      //   cost += iCost.total;
      // }
      const a = f(elId, name, cost);
      this.exportSummaryData.push(a);
    }
  }

  private _elaborateSummaryElement = (elId: string, name: string, b: Budget, f) => {
    if (elId in b.costSummary) {
      const cost = b.costSummary[elId];
      const a = f(elId, name, cost);
      this.summaryData.push(a);
    }
  }


  private _calculatesValue = (margin, ratio?) => {
    const k = (100 - (margin.commission + margin.generalExpenses + margin.profit + margin.customDuties));
    return function (id, name, cost) {
      const a: SummaryElement = {
        id,
        name,
        cost,
        commission: cost * margin.commission / k,
        expenses: cost * margin.generalExpenses / k,
        customDuties: cost * margin.customDuties / k,
        profit: cost * margin.profit / k,
        total: 0,
      };
      a.total = a.cost + a.commission + a.expenses + a.profit + a.customDuties;
      if (ratio) {
        a.totalCurrency = a.total * ratio;
      }
      return a;
    };
  }



}


@Component({
  selector: 'app-document-editor-dialog-component',
  templateUrl: './app-document-editor-dialog.html',
  styleUrls: ['document-editor-dialog.css'],
})
export class DocumentEditorDialogComponent implements OnInit {

  public imageSelectorOpen = false;
  public products = [{name: 'Michelangelo', templateId: '1oVrVAQPF5-h1knr2jwRoaFtDFZTrLsqEAyfCJmg5Nqw'},
    {name: 'Galileo', templateId: '1p0LFFhISweRPxo19lvoycaXeAhArP7ybOpeEnuJZdo8'},
    {name: 'Leonardo', templateId: '19XcMAg1YjM9MHBEiIPXlqGvTMbvRY6zIHFEbCIPukZY'}
  ];
  public productSelected;
  public images = [];

  public imageList = [];

  constructor(
    public dialogRef: MatDialogRef<ContactPickerDialogComponent | OpenProjectDialogComponent | DocumentEditorDialogComponent>,
    private dataService: DataService,

    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    console.log('init');

    this.products = this.data.templates;
    //this.data.budgetFolder
    this.dataService.getBudgetImages(this.data.budgetFolder, this.data.imageFolderPath).first().subscribe((data) => {
      console.log('images', data);

      if (data) {
        this.images = data.files.map(img => {
          return {
            src: img.thumbnailLink,
            title: img.name,
            fileId: img.id
          };
        });
      }
    });
  }

  public toggleImageSelector(el: HTMLElement){

    this.imageSelectorOpen = !this.imageSelectorOpen;
    setTimeout(() => {
      el.scrollIntoView({behavior: 'smooth'});
    }, 400);

  }

  public closeImageSelector(){
    this.imageSelectorOpen = false;
  }


  public addImage(i) {
    const newImage = Object.assign({}, this.images[i]);
    this.imageList.push(newImage);
    this.closeImageSelector();
  }

  public removeImage(i){
    this.imageList.splice(i, 1);
  }

  save() {
      console.log('Closing dialog: ', this.productSelected, this.imageList);
      this.dialogRef.close({
        productSelected: this.productSelected,
        imageList: this.imageList
      });
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}



@Component({
  selector: 'app-contact-picker-dialog',
  templateUrl: './app-contact-picker-dialog.html'
})
export class ContactPickerDialogComponent implements OnInit {

  public filteredOptions: Observable<string[]>;
  public myControl: FormControl = new FormControl(undefined,
    Validators.required);
  public deliveryDateControl: FormControl = new FormControl(undefined,
    Validators.required);
  public noteToPrjMgr: FormControl = new FormControl();
  public minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<ContactPickerDialogComponent | OpenProjectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

  }

  closeDialog() {
    if (this.myControl.valid && this.deliveryDateControl.valid) {
      this.dialogRef.close({
        user: this.myControl.value,
        deliveryThr: this.deliveryDateControl.value,
        noteToPrjMgr: this.noteToPrjMgr.value,
      });
    } else {
      this.deliveryDateControl.markAsTouched({ onlySelf: true });
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}

const intParsableValidator = (control: FormControl) => {
  const number = control.value;
  if (Number.isNaN(parseInt(number, 10))) {
    return { numberParsable: 'Not parsable ' };
  }
  return null;
};

@Component({
  selector: 'app-open-project-dialog',
  template: `<h3 mat-dialog-title i18n>Open Project</h3>
  <mat-dialog-content>
      <mat-form-field>
          <input type="text" placeholder="Project Nr." aria-label="Number" matInput [formControl]="projectNr" maxlength="6" i18n-placeholder>
          <mat-error *ngIf="projectNr.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <mat-form-field>
          <input type="number" placeholder="Total Value" aria-label="Number" matInput [formControl]="totalValue" i18n-placeholder>
      </mat-form-field>
      <app-user-picker placeholder="Project Manager" [myControl]="projectManager"></app-user-picker>
      <mat-form-field>
        <mat-select placeholder="Payment Method" [formControl]="paymentMethod">
          <mat-option *ngFor="let pm of paymentMethodOptions" [value]="pm.methodValue">
            {{ pm.methodValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Delivery Date" [min]="minDeliveryDate" [matDatepicker]="deliveryFormDate" [formControl]="deliveryDate">
        <mat-datepicker-toggle matSuffix [for]="deliveryFormDate"></mat-datepicker-toggle>
        <mat-datepicker #deliveryFormDate></mat-datepicker>
      </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
          <button type="submit" mat-button (click)="closeDialog()" [disabled]="!isValid" i18n>Submit</button>
  </mat-dialog-actions>
  `
})
export class OpenProjectDialogComponent implements OnInit {

  public filteredOptions: Observable<string[]>;
  public projectNr: FormControl = new FormControl(null, [Validators.required, intParsableValidator]);
  public totalValue: FormControl = new FormControl(0, Validators.required);
  public projectManager: FormControl;
  public deliveryDate: FormControl = new FormControl(Date, Validators.required);
  public paymentMethod: FormControl = new FormControl('', Validators.required);
  public paymentMethodCode: FormControl = new FormControl('', Validators.required);

  public paymentMethodsSubscription;
  public minDeliveryDate;

  public paymentMethodOptions = [];

  get isValid() {
    return this.projectNr.valid && this.totalValue.valid && this.projectManager.valid && this.paymentMethod.valid && this.deliveryDate.value;
  }

  constructor(
    public dialogRef: MatDialogRef<ContactPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService
  ) { }

  ngOnInit() {

    this.dataService.getNextProjectNr()
      .subscribe((projectNr) => {
        this.projectNr.setValue(projectNr);
      });

    if (this.data.oData) {
      //
      this.totalValue.setValue(this.data.oData.offerAmount);

    }

    if (this.data.user) {
      // this.projectManager.setValue(this.data.user);
      this.projectManager = new FormControl(this.data.user, Validators.required);
    } else {
      this.projectManager = new FormControl(undefined, Validators.required);
    }

    this.paymentMethodsSubscription = this.dataService.getPaymentMethods()
    .map((paymentMethodsList) => paymentMethodsList.map((paymentMethod) => {
      const data = paymentMethod.payload.doc.data() as PaymentMethods;
      return data;
    }))
    .subscribe((paymentMethods) => {
      this.paymentMethodOptions = paymentMethods;
    });

    this.minDeliveryDate = new Date();

  }

  getErrorMessage() {
    return this.projectNr.hasError('required') ? 'You must enter a value' :
      this.projectNr.hasError('numberParsable') ? 'Project number must start with an integer' :
        '';
  }

  closeDialog() {
    if (this.isValid) {
      const selectedPaymentMethod : any = this.paymentMethodOptions.filter(pm => {
        return pm.methodValue == this.paymentMethod.value;
      })
      const paymentMethodCode = selectedPaymentMethod[0].methodCode;

      this.dialogRef.close({
        projectNr: this.projectNr.value,
        totalValue: this.totalValue.value,
        projectManager: this.projectManager.value,
        paymentMethod: this.paymentMethod.value,
        paymentMethodCode: paymentMethodCode,
        deliveryDate: this.deliveryDate.value
      });
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'app-archive-project-dialog',
  template: `<h3 mat-dialog-title i18n>Archive Project</h3>
  <mat-dialog-content>
      <mat-form-field>
          <input type="number" placeholder="Total Invoiced" aria-label="Number" matInput [formControl]="finalInvoiced" i18n-placeholder>
      </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
          <button type="submit" mat-button (click)="closeDialog()" [disabled]="!isValid" i18n>Submit</button>
  </mat-dialog-actions>
  `
})
export class ArchiveProjectDialogComponent implements OnInit {

  public finalInvoiced: FormControl = new FormControl(0, Validators.required);

  get isValid() {
    return this.finalInvoiced.valid;
  }

  constructor(
    public dialogRef: MatDialogRef<ContactPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Project
  ) { }

  ngOnInit() {

    if (this.data.finalOfferOrder) {
      this.finalInvoiced.setValue(this.data.finalOfferOrder);
    }
  }

  getErrorMessage() {
    return this.finalInvoiced.hasError('required') ? 'You must enter a value' : '';
  }

  closeDialog() {
    if (this.isValid) {
      this.dialogRef.close({
        finalInvoiced: this.finalInvoiced.value,
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

interface SummaryElement {
  id: string;
  name: string;
  cost: number;
  profit: number;
  commission: number;
  expenses: number;
  customDuties: number;
  total: number;
  totalCurrency?: number;
}

interface OfferTemplate {
  id: string;
  name: string;
  locale?: string;
  lang: string;
  templateId: string;
}



// WEBPACK FOOTER //
// ./src/app/budget/budget-detail.component.ts